import { SVGProps } from 'react'

function InputValid(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={22} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="m10.759 12.592-4.25-4.25a1.898 1.898 0 1 1 2.684-2.684l2.704 2.704 5.063-6.75a1.898 1.898 0 1 1 3.036 2.277l-6.376 8.5a1.896 1.896 0 0 1-2.861.203Z"
        stroke="#28BD9A"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="M10.754 4.114 12.63 1.61a1.9 1.9 0 0 1 2.041-.686M8.41 13.038c-.691.246-1.46.072-1.978-.446l-4.25-4.25a1.898 1.898 0 0 1 1.97-3.134"
        stroke="#28BD9A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

InputValid.defaultProps = { role: 'graphics-document' }

export default InputValid
